exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spacer{\r\n\tmargin: 0 15px;\r\n\tcolor: #ddd;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// d:/xampp/htdocs/zenith-admin/src/app/questions/questions.component.css
// module id = ../../../../../src/app/questions/questions.component.css
// module chunks = 1